import { OptionData } from "../OptionList/types";
import { createOption } from "../../../utils/options";
// eslint-disable-next-line
export const optionDataToRSSI = (o: OptionData) =>
  createOption(o.value, o.text);
